import { Complex } from './complex';

export class FFT {

  private Radix2Reorder<T>(samples: T[]): void {
    let j = 0;
    for (let i = 0; i < samples.length - 1; i++) {
      if (i < j) {
        let temp = samples[i];
        samples[i] = samples[j];
        samples[j] = temp;
      }

      let m = samples.length;

      do {
        m >>= 1;
        j ^= m;
      } while ((j & m) == 0);
    }
  }

  private Radix2Step(samples: Complex[], exponentSign: number, levelSize: number, k: number): void {
    // Twiddle Factor
    let exponent = (exponentSign * k) * Math.PI / levelSize;
    let w = new Complex({real: Math.cos(exponent), imag: Math.sin(exponent)});

    let step = levelSize << 1;
    for (let i = k; i < samples.length; i += step) {
      let ai = samples[i];
      let t = w.multiply(samples[i + levelSize]);
      samples[i] = ai.add(t);
      samples[i + levelSize] = ai.subtract(t);
    }
  }

  // this seems to be the function used by the asymetric fft
  public Radix2ForwardParallel(data: Complex[]): void {
    this.Radix2Reorder(data);
    for (let levelSize = 1; levelSize < data.length; levelSize *= 2) {
      let size = levelSize;

      // no parallelization for now
      for (let i = 0; i < size; i++) {
        this.Radix2Step(data, -1, size, i);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fft.ts